// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfCrmGebruikersGetGebruikersByAdviseurDto } from '../model/collectionResultOfCrmGebruikersGetGebruikersByAdviseurDto.ts';

import type { Result1OfCrmAdviseursGetAccountmanagerByAdviseurnummerAccountmanagerDto } from '../model/result1OfCrmAdviseursGetAccountmanagerByAdviseurnummerAccountmanagerDto.ts';

import type { Result1OfCrmAdviseursGetAdviseurByIdAdviseurDto } from '../model/result1OfCrmAdviseursGetAdviseurByIdAdviseurDto.ts';

import type { Result1OfManagementModelsEmpty } from '../model/result1OfManagementModelsEmpty.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Haal een specifieke adviseur op
 */
export const adviseursGetAdviseurById = (
  id: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  id = toValue(id);

  return customInstance<Result1OfCrmAdviseursGetAdviseurByIdAdviseurDto>(
    { url: `/api/v1/adviseurs/${id}`, method: 'GET', signal },
    options,
  );
};

export const getAdviseursGetAdviseurByIdQueryKey = (
  id: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'adviseurs', id] as const;
};

export const getAdviseursGetAdviseurByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof adviseursGetAdviseurById>>,
  TError = ErrorType<void | Result1OfManagementModelsEmpty>,
>(
  id: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetAdviseurById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAdviseursGetAdviseurByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adviseursGetAdviseurById>>> = ({
    signal,
  }) => adviseursGetAdviseurById(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof adviseursGetAdviseurById>>, TError, TData>;
};

export type AdviseursGetAdviseurByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof adviseursGetAdviseurById>>
>;
export type AdviseursGetAdviseurByIdQueryError = ErrorType<void | Result1OfManagementModelsEmpty>;

/**
 * @summary Haal een specifieke adviseur op
 */

export function useAdviseursGetAdviseurById<
  TData = Awaited<ReturnType<typeof adviseursGetAdviseurById>>,
  TError = ErrorType<void | Result1OfManagementModelsEmpty>,
>(
  id: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetAdviseurById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdviseursGetAdviseurByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Haal de adviseur gegevens van de ingelogde gebruiker op
 */
export const adviseursGetHuidigeAdviseur = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfCrmAdviseursGetAdviseurByIdAdviseurDto>(
    { url: `/api/v1/adviseurs`, method: 'GET', signal },
    options,
  );
};

export const getAdviseursGetHuidigeAdviseurQueryKey = () => {
  return ['api', 'v1', 'adviseurs'] as const;
};

export const getAdviseursGetHuidigeAdviseurQueryOptions = <
  TData = Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>,
  TError = ErrorType<void | Result1OfManagementModelsEmpty>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAdviseursGetHuidigeAdviseurQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>> = ({
    signal,
  }) => adviseursGetHuidigeAdviseur(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>,
    TError,
    TData
  >;
};

export type AdviseursGetHuidigeAdviseurQueryResult = NonNullable<
  Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>
>;
export type AdviseursGetHuidigeAdviseurQueryError =
  ErrorType<void | Result1OfManagementModelsEmpty>;

/**
 * @summary Haal de adviseur gegevens van de ingelogde gebruiker op
 */

export function useAdviseursGetHuidigeAdviseur<
  TData = Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>,
  TError = ErrorType<void | Result1OfManagementModelsEmpty>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetHuidigeAdviseur>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdviseursGetHuidigeAdviseurQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Gebruikers ophalen a.d.h.v. adviseur
 */
export const adviseursGetGebruikers = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  adviseurnummer = toValue(adviseurnummer);

  return customInstance<CollectionResultOfCrmGebruikersGetGebruikersByAdviseurDto>(
    {
      url: `/api/v1/adviseurs/${adviseurnummer}/gebruikers`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getAdviseursGetGebruikersQueryKey = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'adviseurs', adviseurnummer, 'gebruikers'] as const;
};

export const getAdviseursGetGebruikersQueryOptions = <
  TData = Awaited<ReturnType<typeof adviseursGetGebruikers>>,
  TError = ErrorType<void>,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetGebruikers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAdviseursGetGebruikersQueryKey(adviseurnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adviseursGetGebruikers>>> = ({ signal }) =>
    adviseursGetGebruikers(adviseurnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(adviseurnummer) !== null && toValue(adviseurnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof adviseursGetGebruikers>>, TError, TData>;
};

export type AdviseursGetGebruikersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adviseursGetGebruikers>>
>;
export type AdviseursGetGebruikersQueryError = ErrorType<void>;

/**
 * @summary Gebruikers ophalen a.d.h.v. adviseur
 */

export function useAdviseursGetGebruikers<
  TData = Awaited<ReturnType<typeof adviseursGetGebruikers>>,
  TError = ErrorType<void>,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetGebruikers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdviseursGetGebruikersQueryOptions(adviseurnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Accountmanager ophalen a.d.h.v. adviseur
 */
export const adviseursGetAccountManager = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  adviseurnummer = toValue(adviseurnummer);

  return customInstance<Result1OfCrmAdviseursGetAccountmanagerByAdviseurnummerAccountmanagerDto>(
    {
      url: `/api/v1/adviseurs/${adviseurnummer}/accountmanager`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getAdviseursGetAccountManagerQueryKey = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'adviseurs', adviseurnummer, 'accountmanager'] as const;
};

export const getAdviseursGetAccountManagerQueryOptions = <
  TData = Awaited<ReturnType<typeof adviseursGetAccountManager>>,
  TError = ErrorType<void>,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetAccountManager>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAdviseursGetAccountManagerQueryKey(adviseurnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adviseursGetAccountManager>>> = ({
    signal,
  }) => adviseursGetAccountManager(adviseurnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(adviseurnummer) !== null && toValue(adviseurnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof adviseursGetAccountManager>>, TError, TData>;
};

export type AdviseursGetAccountManagerQueryResult = NonNullable<
  Awaited<ReturnType<typeof adviseursGetAccountManager>>
>;
export type AdviseursGetAccountManagerQueryError = ErrorType<void>;

/**
 * @summary Accountmanager ophalen a.d.h.v. adviseur
 */

export function useAdviseursGetAccountManager<
  TData = Awaited<ReturnType<typeof adviseursGetAccountManager>>,
  TError = ErrorType<void>,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adviseursGetAccountManager>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdviseursGetAccountManagerQueryOptions(adviseurnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
